import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EServiceMessageActionTypes } from '../../constants/actionTypes/serviceMessageActions';

export const setIsNewYearAlertShown = actionGenerator<EServiceMessageActionTypes.SET_NEW_YEAR_SHOWN, boolean>(
  EServiceMessageActionTypes.SET_NEW_YEAR_SHOWN,
);
export type TSetIsNewYearAlertShown = ReturnType<typeof setIsNewYearAlertShown>;

export const setIsNewYearAlertShouldShown = actionGenerator<
  EServiceMessageActionTypes.SET_NEW_YEAR_SHOULD_SHOWN,
  boolean
>(EServiceMessageActionTypes.SET_NEW_YEAR_SHOULD_SHOWN);
export type TSetIsNewYearAlertShouldShown = ReturnType<typeof setIsNewYearAlertShouldShown>;

export type TServiceMessageActionTypes = TSetIsNewYearAlertShown | TSetIsNewYearAlertShouldShown;
